import React from 'react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useRecoilState } from 'recoil';
import { landingZoneData } from 'pages/app-profiles/store';
import { CssTextField } from 'components/select';

const ComponentName = ({ index }) => {
    const [landingZoneForm] = useRecoilState(landingZoneData);
    const [ShrinkField, setShrinkField] = React.useState(true);

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <CssTextField
                    size="small"
                    label={landingZoneForm?.components?.[index]?.name}
                    value={landingZoneForm?.components?.[index]?.service}
                    InputLabelProps={{ shrink: ShrinkField }}
                    onClick={() => setShrinkField(true)}
                    autoComplete="off"
                    disabled
                />
            </Stack>
        </>
    );
};

ComponentName.propTypes = {
    index: PropTypes.number,
};

ComponentName.defaultProps = {
    index: 0,
};

export default React.memo(ComponentName);
